import { render, staticRenderFns } from "./CoCheckboxInput.vue?vue&type=template&id=42df50d6&"
import script from "./CoCheckboxInput.vue?vue&type=script&lang=ts&"
export * from "./CoCheckboxInput.vue?vue&type=script&lang=ts&"
import style0 from "./CoCheckboxInput.vue?vue&type=style&index=0&id=42df50d6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports